import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireRole } from "@/utils/route-guards";
import { AREA_ROLES } from "@/utils/errandPath";
import { useContentMinHeight } from "@/contexts/LayoutContext";

export const Route = createFileRoute("/end-user")({
  beforeLoad: ({ context, location }) => {
    // The list lives in `AREA_ROLES` rather than here, because the
    // walkthrough's closing line reads it too — a promise about where Finish
    // goes has to be answered from the same list that enforces it.
    requireRole(context, location, AREA_ROLES["/end-user"]);
  },
  component: EndUserLayout,
});

function EndUserLayout() {
  const minHeight = useContentMinHeight();
  // Top-navbar shell: the Navbar in __root carries the
  // end-user nav items; pages render full-width beneath it on the mesh
  // background.
  return (
    <div className="gradient-mesh-animated" style={{ minHeight }}>
      <main className="mx-auto max-w-5xl px-5 md:px-6 py-8 md:py-12 pb-20">
        <Outlet />
      </main>
    </div>
  );
}
